import { Reveal } from "@/components/landing/Reveal";
import { SectionTitle } from "./ui";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SITE, isapresTexto } from "@/config/site";

const faqs = () => {
  const A = SITE.modo === "A";
  return [
    ["¿La asesoría tiene algún costo?", A
      ? `No. La asesoría no tiene costo para ti. La prestan ejecutivos de ventas de ${isapresTexto()}, por lo que no pagas nada por conversar ni por resolver tus dudas.`
      : "No. La asesoría no tiene costo para ti: no pagas nada por conversar, revisar alternativas ni resolver tus dudas."],
    ["¿Puedo cambiarme de Isapre?", "En general sí, aunque depende de tu contrato vigente, tu situación de salud y los plazos de cada caso. Revisamos tu situación y te explicamos qué opciones tienes."],
    ["¿Puedo comparar diferentes planes?", A
      ? `Sí. Te mostramos distintos planes de ${isapresTexto()} y te ayudamos a compararlos con el plan que tienes hoy, para que decidas con información clara.`
      : `Sí. Revisamos alternativas de ${isapresTexto()} y te ayudamos a compararlas con lo que tienes hoy, para que decidas con información clara.`],
    ["¿Qué información necesito para comenzar?", "Solo tu nombre, un teléfono y contarnos tu situación: si hoy tienes Isapre o Fonasa, si buscas un plan individual o familiar y en qué región vives. No necesitas enviar información médica."],
    ["¿Puedo recibir asesoría si ya tengo Isapre?", "Sí. Podemos revisar tu plan actual contigo, explicarte qué cubre y conversar sobre alternativas que se ajusten a tu caso."],
  ];
};

export const Faq = () => (
  <section id="preguntas" data-testid="faq-section" className="bg-[#F4F7F9] py-16 sm:py-24">
    <div className="mx-auto max-w-3xl px-4 sm:px-6">
      <Reveal><SectionTitle title="Preguntas frecuentes" center /></Reveal>
      <Reveal>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs().map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="rounded-2xl border border-[#E3EAEF] bg-white px-5 sm:px-6">
              <AccordionTrigger data-testid={`faq-trigger-${i}`}
                className="py-5 text-left text-[19px] font-bold text-[#0B3C5D] hover:no-underline focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-[#1FA89A]">{q}</AccordionTrigger>
              <AccordionContent className="pb-5 text-[17px] leading-relaxed text-[#3A4753]">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
